module.exports = __webpack_public_path__ + "media/hallBgm.dfd8e315.mp3";